// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ccd117ab","455":"89b69c19"}[chunkId] + ".chunk.js";
};